// LICENSE : MIT
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Deferred = function Deferred() {
    var _this = this;

    _classCallCheck(this, Deferred);

    this.promise = new Promise(function (resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
    });
};

exports.default = Deferred;
//# sourceMappingURL=Deferred.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/kuromojin/lib/Deferred.js
// module id = 42
// module chunks = 0